/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListRiskResultsByChatSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRiskResultsByChatSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRiskResultsByChatSecurity = {
  option1?: ListRiskResultsByChatSecurityOption1 | undefined;
  option2?: ListRiskResultsByChatSecurityOption2 | undefined;
};

export type ListRiskResultsByChatRequest = {
  /**
   * Cursor to fetch the next page of results.
   */
  cursor?: string | undefined;
  /**
   * Maximum number of results to return per page.
   */
  limit?: number | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListRiskResultsByChatSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRiskResultsByChatSecurityOption1$outboundSchema: z.ZodMiniType<
  ListRiskResultsByChatSecurityOption1$Outbound,
  ListRiskResultsByChatSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listRiskResultsByChatSecurityOption1ToJSON(
  listRiskResultsByChatSecurityOption1: ListRiskResultsByChatSecurityOption1,
): string {
  return JSON.stringify(
    ListRiskResultsByChatSecurityOption1$outboundSchema.parse(
      listRiskResultsByChatSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRiskResultsByChatSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRiskResultsByChatSecurityOption2$outboundSchema: z.ZodMiniType<
  ListRiskResultsByChatSecurityOption2$Outbound,
  ListRiskResultsByChatSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listRiskResultsByChatSecurityOption2ToJSON(
  listRiskResultsByChatSecurityOption2: ListRiskResultsByChatSecurityOption2,
): string {
  return JSON.stringify(
    ListRiskResultsByChatSecurityOption2$outboundSchema.parse(
      listRiskResultsByChatSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRiskResultsByChatSecurity$Outbound = {
  Option1?: ListRiskResultsByChatSecurityOption1$Outbound | undefined;
  Option2?: ListRiskResultsByChatSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRiskResultsByChatSecurity$outboundSchema: z.ZodMiniType<
  ListRiskResultsByChatSecurity$Outbound,
  ListRiskResultsByChatSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRiskResultsByChatSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRiskResultsByChatSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRiskResultsByChatSecurityToJSON(
  listRiskResultsByChatSecurity: ListRiskResultsByChatSecurity,
): string {
  return JSON.stringify(
    ListRiskResultsByChatSecurity$outboundSchema.parse(
      listRiskResultsByChatSecurity,
    ),
  );
}

/** @internal */
export type ListRiskResultsByChatRequest$Outbound = {
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRiskResultsByChatRequest$outboundSchema: z.ZodMiniType<
  ListRiskResultsByChatRequest$Outbound,
  ListRiskResultsByChatRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRiskResultsByChatRequestToJSON(
  listRiskResultsByChatRequest: ListRiskResultsByChatRequest,
): string {
  return JSON.stringify(
    ListRiskResultsByChatRequest$outboundSchema.parse(
      listRiskResultsByChatRequest,
    ),
  );
}
